import { Card } from "../card/Card";

interface Props {
  children?: React.ReactNode;
  testID?: string;
  ariaLabel?: string;
  hideBorder?: boolean;
  className?: string;
}

export function ActionList(props: Props) {
  const {
    children,
    testID = "action-list",
    className,
    ariaLabel,
    hideBorder,
  } = props;

  return (
    <Card
      testID={testID}
      className={className}
      ariaLabel={ariaLabel}
      hideBorder={hideBorder}
    >
      {children}
    </Card>
  );
}
